export default __webpack_public_path__ + "static/media/Hammer of Primal Wrath.c462904f.jpg";